export default "__VITE_ASSET__BKwQaVpw__"